import { render, staticRenderFns } from "./name.vue?vue&type=template&id=58c40a32&scoped=true"
import script from "./name.vue?vue&type=script&lang=js"
export * from "./name.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c40a32",
  null
  
)

export default component.exports